// extracted by mini-css-extract-plugin
export default {"optionImage":"multiple-choice_optionImage__r8dA2"};